import * as React from 'react';
import { Segment, Table as UITable } from 'semantic-ui-react';
import { Currency } from '~/Api/InfoCard';
export var PositiveList = function (_a) {
    var detail = _a.detail, children = _a.children;
    return (<div data-testid={detail.type}>
		{children}
		<Segment.Group compact>
			<UITable striped unstackable size='small'>
				<UITable.Body>
					{detail.records.map(function (record, i) { return (<UITable.Row data-testid='record' key={i}>
							<UITable.Cell>{record.brand}</UITable.Cell>
							<UITable.Cell>{record.supplement}</UITable.Cell>
							<UITable.Cell>{record.month}</UITable.Cell>
							<UITable.Cell textAlign='right'>
								{"".concat(String(record.pricePerPackage), " ").concat(Currency[detail.units.code])}
							</UITable.Cell>
						</UITable.Row>); })}
				</UITable.Body>
			</UITable>
		</Segment.Group>
	</div>);
};
